import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';

import { OrderStatusChip } from '../AllOrders/components/OrderStatusChip';

import dateFormatter from './dateFormatter';

const orderStatusFormatter = (params: GridRenderCellParams<App.Order>) => {
  const row = params.row;

  return (
    <Stack direction="column">
      <Typography>{dateFormatter(row.created_at)}</Typography>
      <Box width="fit-content">
        <OrderStatusChip orderStatus={row.status} />
      </Box>
    </Stack>
  );
};

export default orderStatusFormatter;
